import _toConsumableArray from "/ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import * as tslib_1 from "tslib";
import { isArray } from 'vega-util';
import { AXIS_PARTS, AXIS_PROPERTY_TYPE } from '../../axis';
import { POSITION_SCALE_CHANNELS } from '../../channel';
import { defaultTitle } from '../../channeldef';
import { getFirstDefined, keys } from '../../util';

function assembleTitle(title, config) {
  if (isArray(title)) {
    return title.map(function (fieldDef) {
      return defaultTitle(fieldDef, config);
    }).join(', ');
  }

  return title;
}

export function assembleAxis(axisCmpt, kind, config) {
  var opt = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
    header: false
  };

  var _a = axisCmpt.combine(),
      orient = _a.orient,
      scale = _a.scale,
      title = _a.title,
      zindex = _a.zindex,
      axis = tslib_1.__rest(_a, ["orient", "scale", "title", "zindex"]); // Remove properties that are not valid for this kind of axis


  keys(axis).forEach(function (key) {
    var propType = AXIS_PROPERTY_TYPE[key];

    if (propType && propType !== kind && propType !== 'both') {
      delete axis[key];
    }
  });

  if (kind === 'grid') {
    if (!axis.grid) {
      return undefined;
    } // Remove unnecessary encode block


    if (axis.encode) {
      // Only need to keep encode block for grid
      var grid = axis.encode.grid;
      axis.encode = Object.assign({}, grid ? {
        grid: grid
      } : {});

      if (keys(axis.encode).length === 0) {
        delete axis.encode;
      }
    }

    return Object.assign({
      scale: scale,
      orient: orient
    }, axis, {
      domain: false,
      labels: false,
      // Always set min/maxExtent to 0 to ensure that `config.axis*.minExtent` and `config.axis*.maxExtent`
      // would not affect gridAxis
      maxExtent: 0,
      minExtent: 0,
      ticks: false,
      zindex: getFirstDefined(zindex, 0) // put grid behind marks by default

    });
  } else {
    // kind === 'main'
    if (!opt.header && axisCmpt.mainExtracted) {
      // if mainExtracted has been extracted to a separate facet
      return undefined;
    } // Remove unnecessary encode block


    if (axis.encode) {
      var _iterator = _createForOfIteratorHelper(AXIS_PARTS),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var part = _step.value;

          if (!axisCmpt.hasAxisPart(part)) {
            delete axis.encode[part];
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      if (keys(axis.encode).length === 0) {
        delete axis.encode;
      }
    }

    var titleString = assembleTitle(title, config);
    return Object.assign({
      scale: scale,
      orient: orient,
      grid: false
    }, titleString ? {
      title: titleString
    } : {}, axis, {
      zindex: getFirstDefined(zindex, 1) // put axis line above marks by default

    });
  }
}
/**
 * Add axis signals so grid line works correctly
 * (Fix https://github.com/vega/vega-lite/issues/4226)
 */

export function assembleAxisSignals(model) {
  var axes = model.component.axes;

  var _iterator2 = _createForOfIteratorHelper(POSITION_SCALE_CHANNELS),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var channel = _step2.value;

      if (axes[channel]) {
        var _iterator3 = _createForOfIteratorHelper(axes[channel]),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var axis = _step3.value;

            if (!axis.get('gridScale')) {
              // If there is x-axis but no y-scale for gridScale, need to set height/weight so x-axis can draw the grid with the right height.  Same for y-axis and width.
              var sizeType = channel === 'x' ? 'height' : 'width';
              return [{
                name: sizeType,
                update: model.getSizeSignalRef(sizeType).signal
              }];
            }
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return [];
}
export function assembleAxes(axisComponents, config) {
  var _axisComponents$x = axisComponents.x,
      x = _axisComponents$x === void 0 ? [] : _axisComponents$x,
      _axisComponents$y = axisComponents.y,
      y = _axisComponents$y === void 0 ? [] : _axisComponents$y;
  return [].concat(_toConsumableArray(x.map(function (a) {
    return assembleAxis(a, 'main', config);
  })), _toConsumableArray(x.map(function (a) {
    return assembleAxis(a, 'grid', config);
  })), _toConsumableArray(y.map(function (a) {
    return assembleAxis(a, 'main', config);
  })), _toConsumableArray(y.map(function (a) {
    return assembleAxis(a, 'grid', config);
  }))).filter(function (a) {
    return a;
  }); // filter undefined
}